var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{staticClass:"profile-avatar",attrs:{"size":"128"}},[(_vm.user.picture)?_c('v-img',{attrs:{"src":_vm.user.picture}}):_c('v-img',{attrs:{"src":require('@/assets/profile_default@3x.png')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }